<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import ShareSheet from './ShareSheet/index.vue'
import { Button, type ButtonVariants } from '@/components/ui/button'
import { cn } from '~~/src/utils'

interface Props {
  feedView?: boolean
}

const props = defineProps<{
  class?: HTMLAttributes['class']
  btnVariant?: ButtonVariants['variant']
  iconClass?: HTMLElement['className']
}>()

defineOptions({
  name: 'ShareElemental',
})
</script>

<template>
  <ShareSheet>
    <Button
      aria-label="share"
      :variant="btnVariant || (feedView ? 'snack-ghost' : 'snack-icon')"
      :size="feedView ? 'sm' : 'icon'"
      icon="sm"
      :class="cn('text-soft-black font-700 text-xs [&_svg]:w-5 [&_svg]:h-5 w-10 h-10', props.class)"
    >
      <IconShare :class="props.iconClass" />
    </Button>
  </ShareSheet>
</template>
